"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseMessageEndpointOut = void 0;
class ListResponseMessageEndpointOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseMessageEndpointOut.attributeTypeMap;
    }
}
exports.ListResponseMessageEndpointOut = ListResponseMessageEndpointOut;
ListResponseMessageEndpointOut.discriminator = undefined;
ListResponseMessageEndpointOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<MessageEndpointOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseMessageEndpointOut.js.map